import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { WebviewService } from '../services/platform/webview.service';
import device from 'current-device';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    google: typeof google;
  }
}

let googleMapsLoadingPromise: Promise<boolean> | null = null;

export const googleSearchResolver: ResolveFn<boolean> = (route, state) => {
  const webviewService = inject(WebviewService);

  const getGMapApiKey = (): string => {
    if (webviewService.IsGPSTWebview() && device?.ios?.()) {
      return environment.GMAPS_API_KEY_IOS;
    }
    else if (webviewService.IsGPSTWebview() && device?.android?.()) {
      return environment.GMAPS_API_KEY_ANDROID;
    }
    else {
      return environment.GMAPS_API_KEY_WEB;
    }
  };

  if (googleMapsLoadingPromise) {
    return googleMapsLoadingPromise;
  }

  googleMapsLoadingPromise = new Promise<boolean>((resolve, reject) => {

    // Already loaded
    if (window.google?.maps) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${getGMapApiKey()}&libraries=places&loading=async`;
    script.async = true;
    script.defer = true;

    script.onload = async () => {
      try {
        resolve(true);
      } catch (err) {
        reject(err);
      }
    };

    script.onerror = reject;

    document.head.appendChild(script);
  });

  return googleMapsLoadingPromise;
};
